import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const AdImagesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 15px;
`;

export const AdImagesAddButton = styled.button<{ $isFullWidth?: boolean }>`
  border-radius: 7px;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  background-color: ${({ theme }) => theme.palette.secondary.background};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: ${({ $isFullWidth }) => ($isFullWidth ? '105px' : 'auto')};
  color: ${({ theme }) => theme.palette.system.blue};
  font-size: 15px;
  font-weight: 400;
  width: 100%;
  aspect-ratio: 1;
`;

export const AdImagesCaption = styled(Typography.Caption)`
  color: ${({ theme }) => theme.palette.secondary.labels};

  &:first-of-type {
    margin-top: 10px;
  }

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;
